import { BaseChart } from '@components/common';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { StyledCard } from './styled';

import moment from 'moment';
import { isEmpty } from 'lodash';
import { Skeleton, Tooltip } from 'antd';
import { buildEventHeatMap, formatTimeInfo } from './hooks/utils';
import useCauseAlerts from './hooks/useCauseAlerts';
import { InfoCircleOutlined } from '@ant-design/icons';
import { HeatMapColors } from '../styled';
import { TOOLTIP_LABEL_FORMAT } from '@utils/constants';

// TODO: build common option for ai/manual alert heat maps
const buildOption = (chartData) => {
  return {
    tooltip: {
      formatter: function ({ data }) {
        return `${data[0]}: ${data[1]}`;
      },
    },
    visualMap: {
      // min: 0,
      // max: 100,
      // type: 'piecewise',
      orient: 'horizontal',
      left: 'center',
      bottom: 10,
      min: 0,
      max: 50,
      calculable: true,
      color: HeatMapColors,
    },
    calendar: {
      top: 25,
      left: 30,
      right: 10,
      bottom: 80,
      // cellSize: 30,
      range: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      yearLabel: { show: false },
      orient: 'vertical',
      dayLabel: {
        firstDay: 1,
        nameMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    },
    series: {
      type: 'heatmap',
      coordinateSystem: 'calendar',
      data: chartData,
      label: {
        show: true,
        formatter: ({ data }) => data[1],
      },
    },
  };
};

function HeatMap({ alert }) {
  const [instance, setInstance] = useState(null);
  const chartInstanceRefCb: any = useCallback((instance) => {
    setInstance(instance);
  }, []);

  const { isFetching, alerts, interval }: any = useCauseAlerts({ alert });

  const chartData = useMemo(() => {
    if (alerts) {
      const chartData = buildEventHeatMap(alerts);
      return chartData;
    }
  }, [alerts]);

  useEffect(() => {
    if (instance) {
      const option = buildOption(chartData);
      instance.setOption(option);
    }
  }, [instance, chartData]);

  if (isFetching || isEmpty(alert)) {
    return (
      <StyledCard bordered={false}>
        <Skeleton />
      </StyledCard>
    );
  }

  return (
    <StyledCard
      title={<h4>Alerts Heat Map (Up to {moment(interval.to).format(TOOLTIP_LABEL_FORMAT)})</h4>}
      extra={
        <Tooltip title={formatTimeInfo(interval)}>
          <InfoCircleOutlined />
        </Tooltip>
      }
    >
      <BaseChart
        key="alert-heat-map"
        chartId="alert-heat-map"
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: '100%', minHeight: 240 }}
      />
    </StyledCard>
  );
}

export default HeatMap;
